import { render, staticRenderFns } from "./KeyThirtySix.vue?vue&type=template&id=2714f094&scoped=true&"
import script from "./KeyThirtySix.vue?vue&type=script&lang=js&"
export * from "./KeyThirtySix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714f094",
  null
  
)

export default component.exports